import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Report } from '../../models/report.model';
import { ErrorState, ErrorStateService } from '../../state/error-state.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-details-dossier',
  templateUrl: './details-dossier.component.html',
  styleUrls: ['./details-dossier.component.scss'],
})
export class DetailsDossierComponent implements OnInit {
  @Input() detailsDossier!: Report.Case;
  @Input() isLoading = false;

  detailsDossierInternal!: Report.Case;
  errorMessage: string | null = null;
  errorStatus: number | null = null;
  isFormValid = false;

  private readonly destroy$ = new Subject<void>();

  @Output() detailsDossierChanged = new EventEmitter<Report.Case>();
  @Output() detailsDossierEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  constructor(private readonly errorStateService: ErrorStateService) {}

  ngOnInit(): void {
    this.errorStateService.errorState$
      .pipe(takeUntil(this.destroy$))
      .subscribe((errorState: ErrorState) => {
        this.errorMessage = errorState.message;
        this.errorStatus = errorState.status;
      });
  }

  onDetailsDossierChanged(detailsDossier: Report.Case): void {
    this.detailsDossierInternal = detailsDossier;
  }

  onSaveSection(): void {
    if (this.isFormValid) {
      this.detailsDossierChanged.emit(this.detailsDossierInternal);
    }
  }

  onEnabled(isEnabled: boolean): void {
    this.detailsDossierEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }

  onCleanError() {
    if (this.errorStatus && this.errorMessage) {
      this.errorStateService.clearError();
    }
  }

  onFormChange($event: boolean) {
    this.isFormValid = $event;
  }
}
